import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { MST1020_R01_BomDto } from "./Dto_MST1020_R01";
import { BomDto } from "src/dtos/bom/BomDto";
import { MST1020_R01Filter } from "./Store_MST1020_R01";

const bomUrl = `${config.apiUrl}/MST1020_R01`;


export const getMST1020_R01Items = async (option: string, params: Partial<MST1020_R01Filter>, listLength: number = 0) => {

	const url = `${bomUrl}/items/${option}`;

	return await getData<ResponseDto<ItemDto[]>>(url, { params: {
		...params,
		listLength
	} })
}

export const getMST1020_R01ItemsAllCount = async (params: Partial<MST1020_R01Filter>) => {
    const url = `${bomUrl}/items/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

export const getMST1020_R01List = async (prntItemcd?: string, bomUseyn?: string) => {
	return await getData<ResponseDto<MST1020_R01_BomDto[]>>(bomUrl, {
		params: {
			prntItemcd,
			bomUseyn
		}
	})
}

export const createMST1020_R01 = async (data: Partial<MST1020_R01_BomDto>[]) => {
	return await postData<Partial<MST1020_R01_BomDto>[], ResponseDto<MST1020_R01_BomDto[]>>(bomUrl, data);
}

export const createSingleMST1020_R01 = async (data: Partial<MST1020_R01_BomDto>) => {
	return await postData<Partial<MST1020_R01_BomDto>, ResponseDto<MST1020_R01_BomDto>>(bomUrl, data);
}

export const patchMST1020_R01 = async (data: Partial<MST1020_R01_BomDto>[]) => {
	return await patchData<Partial<MST1020_R01_BomDto>[], ResponseDto<any>>(bomUrl, data);
}

export const patchSingleMST1020_R01 = async (data: Partial<MST1020_R01_BomDto>) => {
	return await patchData<Partial<MST1020_R01_BomDto>, ResponseDto<any>>(bomUrl, data);
}

// ✅ BOM 비활성화: bomUseyn을 'N'으로 변경 (실제 삭제가 아님)
export const deleteSingleMST1020_R01 = async (data: Partial<MST1020_R01_BomDto>) => {
	return await patchData<Partial<MST1020_R01_BomDto>, ResponseDto<any>>(`${bomUrl}/delete`, data);
}

// ⚠️ Deprecated: 백엔드에서 주석처리됨
export const deleteMST1020_R01 = async (prntItemcd: string, childItemcd: string) => {
	const url = `${bomUrl}/${prntItemcd}/${childItemcd}`;
	return await deleteData<ResponseDto<any>>(url);
}

// ⚠️ Deprecated: 백엔드에서 주석처리됨
export const deleteMST1020_R01List = async (bomIds: Pick<BomDto, 'prntItemcd' | 'bomUpdateNo' | 'childItemcd'>[]) => {
	return await deleteData<ResponseDto<any>>(bomUrl, { data: bomIds });
}

export const downloadExcel_MST1020_R01 = async (prntItemcd?: string, bomUseyn?: string) => {
	const url = `${bomUrl}/excel/`

	return await getData<ResponseDto<string>>(url, { 
		params: {
			prntItemcd,
			bomUseyn
		} 
	})
} 